import { Navigate } from 'react-router-dom';
import { canAccess } from '../../helper/permissions';

const RequirePermission = ({ permissions, menuKey, action = 'view', children }) => {
  if (!canAccess(permissions, menuKey, action)) {
    return <Navigate to="/admin" replace />;
  }
  return children;
};

export default RequirePermission;
